/**
 * Created by Miguel on 23/05/2017
 */



import { Component, HostListener,OnInit, Input,ViewChild,ChangeDetectionStrategy, ViewEncapsulation  } from '@angular/core';
import { ActivatedRoute,RouterLink} from '@angular/router';
import { DomSanitizer,  SafeResourceUrl , SafeHtml } from '@angular/platform-browser';
import { Subscription } from 'rxjs/Subscription';
import { EventBean } from '../../beansts/Event';
import { CompanyService }  from '../../services/company.service';
import { WalletService }  from '../../services/wallet.services';

import { AppDataService }  from '../../services/app-data.service';
import {CompanyBean} from "../../beansts/company.bean";
import { MessagingService } from "../../messaging.service";
import {Router} from "@angular/router";
import {TranslationService} from '../../services/translation.service';
import {EventComponent} from './event.component'
import { MenuConfigurationBean } from '../../beansts/menu.configuration.bean';
import {FormBuilder, FormGroup} from "@angular/forms";

//teleview
declare var Swal : any;
declare var $ : any;
@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated,
    selector : 'gameEvent',
    templateUrl:'gameevent.component.html',
    providers  : []
})
export class GameEventComponent extends EventComponent implements OnInit {



  @Input() myRoom: string;


    public event: EventBean=new EventBean();
    public mobile = false;

    public muted;

    public door;
    public iframeVolume;
    public queryRoom=null;

    public user={uid:'n/a',full_name:'Anonimo',profile_picture:'nil'};
    public userOnView;
    public openContact=false;
    public chatId;
    public loginTab=false;
    public tables=[];
    public notification;
    public hasTele=false;
    public mytable={};
    public countdown='';


    public zoomControl=0;

    public partyMembersRef;
    public conference=true;
    public loadingConference=false;
    public hasCamera=true;
    public bigConference=false;
    public bigStream=false;
    public videoCall='';

    public admin= false;
    public video='DESLIGAR VIDEO'

    public changed=null;
    public loveList=[];
    public userList=[];



    public nameTable=true;
    public chooseFriends=false;

    public language="pt"
    public notificationsON=false;
    public tab=1;
    public canLove=false;



    public companyEvents:EventBean [];
    public company:CompanyBean=new CompanyBean();

    constructor( public _sanitizer: DomSanitizer,public translate: TranslationService, public _router : Router,public _routeParams : ActivatedRoute,public _companyService : CompanyService,public _walletService : WalletService, public _appData : AppDataService,public msgService: MessagingService,public fb : FormBuilder) {
      super( _sanitizer, translate, _router,_routeParams, _companyService,_walletService,  _appData,msgService,fb)
      this.menuConfig=new MenuConfigurationBean();
    }
    public ngOnDestroy() {

    }


    public processRoomMenu(){
      this.menuConfig.parse(this._appData.room.menuConfig);
      if (this._appData.admin){
        this.menuConfig.noCell=false;
        this.menuConfig.noBag=false;
      }
      if (this._appData.instagramUser && this._appData.instagramUser.uid=='T6sKpIAzwlPlYmEGgy2FuolQ2wN2'){
        this.menuConfig.noCell=false;
       this.menuConfig.noBag=false;
      }
    }


}





// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/gameevent.component.ts